package org.zq.astrock_ai.platform

actual object LocalAlertNotifier {
    actual fun notify(title: String, body: String) {
        runCatching { showBrowserNotification(title, body) }
    }

    actual fun prepare() {
        runCatching {
            val ctor = js("typeof Notification !== 'undefined' ? Notification : null")
            if (ctor == null) return
            val permission = ctor.asDynamic().permission as? String ?: return
            if (permission == "default") {
                ctor.asDynamic().requestPermission()
            }
        }
    }
}

private fun showBrowserNotification(title: String, body: String) {
    val ctor = js("typeof Notification !== 'undefined' ? Notification : null")
    if (ctor == null) return
    val permission = ctor.asDynamic().permission as? String ?: return
    when (permission) {
        "granted" -> {
            js("new Notification(title, { body: body })")
        }
        "default" -> {
            ctor.asDynamic().requestPermission().then { result ->
                if (result == "granted") {
                    js("new Notification(title, { body: body })")
                }
            }
        }
    }
}
